export { default } from './TransferPanelPositionJournal';



// WEBPACK FOOTER //
// ./src/components/TransferPanelPositionJournal/index.js